import React ,{useEffect,useState} from 'react'
import styles from './index.module.css'
const Index = (props) =>{
  const { screenData } = props;
  const [scale,setScale] = useState(1);
  const debounce =(fn,wait) =>{
    let timer = null;
    return function(){
        if(timer !== null){
            clearTimeout(timer);
        }
        timer = setTimeout(fn,wait);
    }
  }
  const adaptScreen = () =>{
    const windowWidth = window.innerWidth ; // * window.devicePixelRatio;
    const {screenWidth} = screenData
    let calculateScale = (windowWidth / screenWidth)
    setScale(calculateScale)
  }

  const debounceCalcScale = debounce(adaptScreen,1000)

 
 
  useEffect(() =>{
    adaptScreen()
    window.addEventListener('resize', debounceCalcScale)
    return () => {
      window.removeEventListener('resize', debounceCalcScale)
    }
  })
  
  
  
  return <div className={styles['adapt-content']} >
      <div className={styles['adapt-view']}  style={{width:screenData.screenWidth,height:screenData.screenHeight,transform:`scale(${scale}) translate(-50%)`}}  >
        {
          props.children
        }
      </div>
  </div>
}

export default Index;